import api from "../../index.js";
import { qs } from "../../../utils/utils.js";

export const GetIBDashboardApi = () => api.get('ibusermaster/ib-dashboard');
export const GetIBOverviewApi = (params) => api.get(`ibusermaster/overview-lot-earning-details?${qs(params)}`);
export const GetMySubIbApi = (params) => api.get(`ibusermaster/get-my-subib-team/${qs(params)}`);
export const GetTeamPerformanceApi = (params) => api.get(`ibusermaster/get-my-ibclient-team-performance?${qs(params)}`);